import { useDeviceType } from 'contexts/ThemeContext/hooks/useDeviceType';
import { useLayoutElementsHeight } from 'hooks/useLayoutElementsHeight';
import { useMemo } from 'react';

export const useCommonModalSlotProps = (
  variant: 'left-half' | 'right-half' | 'fullscreen' | 'below-app-bar' = 'fullscreen',
) => {
  const { isDesktop } = useDeviceType();
  const { appBarHeight } = useLayoutElementsHeight();

  const contentWidth = useMemo(() => {
    if (variant === 'left-half' || variant === 'right-half') {
      return isDesktop ? '50%' : '100%';
    }
    return '100%';
  }, [variant, isDesktop]);

  const contentTop = useMemo(() => {
    if (variant === 'left-half' || variant === 'right-half') {
      return isDesktop ? appBarHeight : 0;
    }
    if (variant === 'below-app-bar') {
      return appBarHeight;
    }
    return 0;
  }, [variant, appBarHeight, isDesktop]);

  const contentRight = useMemo(() => {
    if (variant === 'right-half') {
      return 0;
    }
    return 'auto';
  }, [variant]);

  const contentLeft = useMemo(() => {
    if (variant === 'left-half' || variant === 'below-app-bar') {
      return 0;
    }
    return 'auto';
  }, [variant]);

  return {
    slotProps: {
      root: {
        style: {
          top: contentTop,
          left: contentLeft,
          right: contentRight,
          width: contentWidth,
        },
      },
      backdrop: {
        style: {
          top: contentTop,
          left: contentLeft,
          right: contentRight,
          width: contentWidth,
        },
      },
    },
  };
};
